exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-breadcrumbs[data-v-098746a0]{padding-top:17px}.about-breadcrumbs a[data-v-098746a0],.about-breadcrumbs span[data-v-098746a0]{padding-right:5px;padding-left:5px}.about-breadcrumbs a[data-v-098746a0]{color:hsla(0,0%,100%,.8)!important}.about-breadcrumbs a[data-v-098746a0]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-098746a0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/atoms/PmBreadCrumbs.vue
// module id = 152
// module chunks = 0